import React from 'react';
import { useTranslation } from 'react-i18next';

// ============================================================
// MarketingFooter - ported from novala-marketing sections/Footer.tsx
// Matches marketing site design exactly. Uses react-i18next.
// Background #0A0A0A, 4 column links, social icons, corporate.
// ============================================================

const PRODUCT_LINKS = [
  { key: 'payroll', href: 'https://www.getnovala.com/features' },
  { key: 'accounting', href: 'https://www.getnovala.com/features' },
  { key: 'invoicing', href: 'https://www.getnovala.com/features' },
  { key: 'workforce', href: 'https://www.getnovala.com/features' },
  { key: 'vela', href: 'https://www.getnovala.com/features' },
];
const FEATURE_LINKS = [
  { key: 'payments', href: 'https://www.getnovala.com/features' },
  { key: 'cashFlow', href: 'https://www.getnovala.com/features' },
  { key: 'scheduling', href: 'https://www.getnovala.com/features' },
  { key: 'craFiling', href: 'https://www.getnovala.com/features' },
  { key: 't4Forms', href: 'https://www.getnovala.com/features' },
];
const RESOURCE_LINKS = [
  { key: 'sbHub', href: 'https://www.getnovala.com/help' },
  { key: 'payrollCalc', href: 'https://www.getnovala.com/features' },
  { key: 'invoiceGen', href: 'https://www.getnovala.com/features' },
  { key: 'guides', href: 'https://www.getnovala.com/help' },
  { key: 'blog', href: 'https://www.getnovala.com/help' },
];
const LEARN_LINKS = [
  { key: 'helpCenter', href: 'https://www.getnovala.com/help' },
  { key: 'gettingStarted', href: 'https://www.getnovala.com/help' },
  { key: 'tutorials', href: 'https://www.getnovala.com/help' },
  { key: 'contactSupport', href: 'https://www.getnovala.com/contact' },
  { key: 'systemStatus', href: 'https://www.getnovala.com/help' },
];
const CORPORATE_LINKS = [
  { key: 'about', href: 'https://www.getnovala.com/about' },
  { key: 'careers', href: 'https://www.getnovala.com/careers' },
  { key: 'press', href: 'https://www.getnovala.com/about' },
  { key: 'partners', href: 'https://www.getnovala.com/contact' },
];

const linkStyle = { fontSize: 14, color: 'rgba(255,255,255,0.85)', textDecoration: 'none' };
const socialLink = { display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 36, height: 36, opacity: 0.8, color: 'white' };

export default function MarketingFooter() {
  const { t } = useTranslation();

  const Column = ({ titleKey, links, colKey }) => (
    <div>
      <div style={{ fontSize: 16, fontWeight: 700, color: 'white', marginBottom: 24 }}>{t('footer.columns.' + colKey + '.title')}</div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
        {links.map(({ key, href }) => (
          <a key={key} href={href} style={linkStyle}>{t('footer.columns.' + colKey + '.links.' + key)}</a>
        ))}
      </div>
    </div>
  );

  return (
    <footer style={{ background: '#0A0A0A', color: 'white', padding: '80px 64px 40px' }}>
      <div style={{ maxWidth: 1280, margin: '0 auto' }}>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 40, marginBottom: 64 }}>
          <Column titleKey='products' links={PRODUCT_LINKS} colKey='products' />
          <Column titleKey='features' links={FEATURE_LINKS} colKey='features' />
          <Column titleKey='resources' links={RESOURCE_LINKS} colKey='resources' />
          <Column titleKey='learn' links={LEARN_LINKS} colKey='learn' />
        </div>

        <div style={{ borderTop: '1px solid rgba(255,255,255,0.2)', borderBottom: '1px solid rgba(255,255,255,0.2)', padding: '24px 0', marginBottom: 40, display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 24 }}>
          <a href='https://www.getnovala.com/sitemap' style={{ fontSize: 14, color: 'white', textDecoration: 'none' }}>{t('footer.sitemap')}</a>
          <div style={{ fontSize: 14, color: 'white' }}>{t('footer.country.label')}</div>
          <div style={{ display: 'flex', gap: 16, alignItems: 'center' }}>
            <a href='#' aria-label='Facebook' style={socialLink}>
              <svg width='20' height='20' viewBox='0 0 24 24' fill='currentColor'><path d='M9.101 23.691v-7.98H6.627v-3.667h2.474v-1.58c0-4.085 1.848-5.978 5.858-5.978.401 0 .955.042 1.468.103a8.68 8.68 0 0 1 1.141.195v3.325a8.623 8.623 0 0 0-.653-.036 26.805 26.805 0 0 0-.733-.009c-.707 0-1.259.096-1.675.309a1.686 1.686 0 0 0-.679.622c-.258.42-.374.995-.374 1.752v1.297h3.919l-.386 2.103-.287 1.564h-3.246v8.245C19.396 23.238 24 18.179 24 12.044c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.628 3.874 10.35 9.101 11.647Z'/></svg>
            </a>
            <a href='#' aria-label='X' style={socialLink}>
              <svg width='18' height='18' viewBox='0 0 24 24' fill='currentColor'><path d='M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z'/></svg>
            </a>
            <a href='#' aria-label='YouTube' style={socialLink}>
              <svg width='22' height='22' viewBox='0 0 24 24' fill='currentColor'><path d='M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z'/></svg>
            </a>
            <a href='https://www.linkedin.com/company/getnovala/' target='_blank' rel='noopener noreferrer' aria-label='LinkedIn' style={socialLink}>
              <svg width='20' height='20' viewBox='0 0 24 24' fill='currentColor'><path d='M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.063 2.063 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z'/></svg>
            </a>
          </div>
        </div>

        <div style={{ marginBottom: 40 }}>
          <img src='/logo-full-green.svg' alt='Novala' style={{ height: 32, width: 'auto' }} />
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 40 }}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
            {CORPORATE_LINKS.map(({ key, href }) => (
              <a key={key} href={href} style={linkStyle}>{t('footer.corporate.' + key)}</a>
            ))}
          </div>
          <div>
            <p style={{ fontSize: 14, lineHeight: 1.5, color: 'white', marginBottom: 14 }}>{t('footer.copyright')}</p>
            <p style={{ fontSize: 14, lineHeight: 1.5, color: 'white' }}>{t('footer.trademark')}</p>
          </div>
          <div style={{ fontSize: 14, textAlign: 'right', color: 'white' }}>
            <a href='https://www.getnovala.com/terms' style={{ color: 'white', textDecoration: 'none' }}>{t('footer.legal.legal')}</a>
            <span style={{ margin: '0 10px', color: 'rgba(255,255,255,0.8)' }}>|</span>
            <a href='https://www.getnovala.com/privacy' style={{ color: 'white', textDecoration: 'none' }}>{t('footer.legal.privacy')}</a>
            <span style={{ margin: '0 10px', color: 'rgba(255,255,255,0.8)' }}>|</span>
            <a href='https://www.getnovala.com/security' style={{ color: 'white', textDecoration: 'none' }}>{t('footer.legal.security')}</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
